import React from 'react'
import { useTranslation } from 'react-i18next'

import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import PlaceTypeSelect from '../../../../containers/places/select/PlaceTypeSelect'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const PlaceTypeSection = ({ disabled = false }) => {
  const { t } = useTranslation('export')
  const { entity } = useForm()
  if (!['serviceOrder', 'asset'].includes(entity)) return false

  return (
    <>
      <FormItem
        label={t('type') + '*'}
        Input={PlaceTypeSelect}
        path={['filter', 'placeTypes']}
        mergeOptions={[{ id: undefined, name: t('all') }]}
        disabled={disabled}
      />
      <Separator weight={4} />
    </>
  )
}

export default PlaceTypeSection
